import { render, staticRenderFns } from "./AddSegment.vue?vue&type=template&id=55989b1c&"
import script from "./AddSegment.vue?vue&type=script&lang=js&"
export * from "./AddSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports